/**
 * @generated SignedSource<<5a6f28c5a20e31a2115d0bdbccbeef6d>>
 * @relayHash 51a2952d1c677c2ba58161081e80c6c9
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/ContactBuyerFormMutation

import { ConcreteRequest } from 'relay-runtime';
export type MessageOpopValidationMode = "SKIP_VALIDATION" | "VALIDATE_AND_IGNORE" | "VALIDATE_AND_THROW" | "%future added value";
export type MessageRedactionMode = "CHECK_AND_IGNORE_REDACTION" | "REDACT" | "SKIP_REDACTION" | "%future added value";
export type SaveMessageInput = {
  attachmentDir?: string | null;
  attempt?: number | null;
  clientMutationId?: string | null;
  conversationServiceId?: string | null;
  isFromMessageCenter?: boolean | null;
  isFromSeller: boolean;
  itemAttachmentIds?: ReadonlyArray<string | null> | null;
  itemId?: string | null;
  opopValidationMode?: MessageOpopValidationMode | null;
  pageContext?: string | null;
  recipientId?: string | null;
  redactionMode?: MessageRedactionMode | null;
  senderId: string;
  subject?: string | null;
  textBody: string;
  videoAttachments?: ReadonlyArray<MessageVideoAttachmentInput | null> | null;
};
export type MessageVideoAttachmentInput = {
  assetId?: string | null;
  fileSize?: number | null;
  vimeoId?: string | null;
};
export type ContactBuyerFormMutation$variables = {
  input: SaveMessageInput;
};
export type ContactBuyerFormMutation$data = {
  readonly saveMessage: {
    readonly conversation: {
      readonly serviceId: string | null;
    } | null;
  } | null;
};
export type ContactBuyerFormMutation = {
  response: ContactBuyerFormMutation$data;
  variables: ContactBuyerFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContactBuyerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SaveMessagePayload",
        "kind": "LinkedField",
        "name": "saveMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "ContactBuyerFormMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "SaveMessagePayload",
        "kind": "LinkedField",
        "name": "saveMessage",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Conversation",
            "kind": "LinkedField",
            "name": "conversation",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/568.0.0-2026-07-14T15:45:41.645Z/ContactBuyerFormMutation",
    "metadata": {},
    "name": "ContactBuyerFormMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4995cafeaef530ece3af271604da2521";

export default node;
